module.exports = __webpack_public_path__ + "img/lang_right_btn.ee8bcd09.svg";